import { RequestAPI } from '../Requests';
import { getLangHeaders } from '../utils';
import type {
  V3CalculateRequest,
  V3CalculateResponse,
  V3NewRequest,
  V3NewResponse,
} from './types';

const V3_ENDPOINTS = {
  calculate: 'orders/v3/calculate',
  new: 'orders/v3/new',
} as const;

export const V3Requests = {
  calculate: (data: V3CalculateRequest): Promise<V3CalculateResponse> =>
    RequestAPI.post(V3_ENDPOINTS.calculate, data as never, getLangHeaders()),

  newOrder: (
    data: V3NewRequest,
    idempotencyKey: string,
  ): Promise<V3NewResponse> =>
    RequestAPI.post(V3_ENDPOINTS.new, data as never, {
      headers: {
        'Idempotency-Key': idempotencyKey,
        ...getLangHeaders().headers,
      },
    }),
};
